/**
 * What a student should see about a live class, outside the lesson player.
 *
 *   invite   – their class is live and they have not joined: show only "Join class".
 *   waiting  – joined, the teacher has not launched anything yet.
 *   opening  – joined and a lesson is live; ClassLaunchRouter is taking them in.
 *   none     – nothing live.
 *
 * Pure, so the rule is tested without Firestore or React.
 */

interface SessionLike {
  id?: string;
  status?: string;
  session_code?: string;
  launched_lesson?: unknown;
  launched_scene?: unknown;
}

export type StudentLiveState<S extends SessionLike> =
  | { kind: 'none' }
  | { kind: 'invite'; session: S }
  | { kind: 'waiting'; session: SessionLike }
  | { kind: 'opening'; session: SessionLike };

const isLive = (s: SessionLike | null | undefined): s is SessionLike => !!s && s.status !== 'ended';

export function studentLiveState<S extends SessionLike>(
  joinedSession: SessionLike | null | undefined,
  sessions: S[]
): StudentLiveState<S> {
  if (isLive(joinedSession)) {
    return joinedSession.launched_lesson || joinedSession.launched_scene
      ? { kind: 'opening', session: joinedSession }
      : { kind: 'waiting', session: joinedSession };
  }
  const invite = sessions.find(isLive);
  return invite ? { kind: 'invite', session: invite } : { kind: 'none' };
}
